import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getReportDetail, loadReportDetailsParam, ReportDetailsResult } from "@tKgpco/Services/PowerBiService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<loadReportDetailsParam, ReportDetailsResult>;

export const RequestPowerBIReportFromApi: HandlerType = async props => {
    const result = await getReportDetail(props.parameter);

    if (result.token) {
        props.apiResult = result;
        props.parameter?.onSuccess?.(result);
    } else {
        props.parameter?.onError?.("Report Not Found");
        return false;
    }
};

export const chain = [RequestPowerBIReportFromApi];
const getPowerBIReportDetail = createHandlerChainRunner(chain, "getPowerBIReportDetail");
export default getPowerBIReportDetail;
